/** @jsxImportSource @emotion/react */
import React, { Fragment } from 'react';

import useStyles from './styles';

const externalLinkAttributes = {
  target: '_blank',
  rel: 'nofollow noopener noreferrer',
};
const ExternalLink = React.forwardRef(
  ({ children, href, id, isLink = true, ...rest }, ref) => {
    const styles = useStyles();
    if (!isLink) {
      return <Fragment key={id}>{children}</Fragment>;
    }
    const isAbsoluteUrl = /^https?:\/\//i.test(href);
    const attributes = {
      ...(isAbsoluteUrl ? externalLinkAttributes : {}),
      ...rest,
    };

    return (
      <a href={href} css={styles.link} ref={ref} {...attributes}>
        {children}
      </a>
    );
  }
);

export default ExternalLink;
